import './index.css';

export default {
  name: 'ApasswordInput',
  props: {
    value: { type: String, default: () => '' },
  },
  data() {
    return {
      active: 0,
      content: this.value,
    }
  },
  methods: {
    input(value) {
      const { min = 6 } = this.$attrs;
      this.content = value;
      let mode = 0;
      if (/\d/.test(value)) mode++; //数字
      if (/\W/.test(value)) mode++; //字符
      if (/[a-z]/.test(value)) mode++; //小写
      if (/[A-Z]/.test(value)) mode++; //大写
      if (value.length < min) this.active = 0;
      if (value.length > min && mode < 2) this.active = 1;
      if (value.length > min && mode > 2) this.active = 2;
      if (value.length > min && mode > 3) this.active = 3;
      this.$emit('input', this.content);
    },
  },
  render() {
    const {
      min = 6,
      max = 20,
      hint = true,
      type = 'password',
      showPassword = true,
      placeholder = '请输入密码',
      option = [
        { label: '低', color: '' },
        { label: '中', color: '' },
        { label: '高', color: '' },
      ],
      ...attrs
    } = this.$attrs;
    return (
      <div class="a-password-input">
        <el-input
          on-input={a => a.length <= max && (this.input(a))}
          show-password={showPassword}
          placeholder={placeholder}
          v-model={this.content}
          minlength={min}
          maxlength={max}
          type={type}
          {...{ attrs }}
        />
        {hint && (
          <div class="a-password-input-hint">
            {option.map((a, b) => {
              // let label = a.label || a.title || a.text || `${a}`;
              // return (<div key={b} class={`a-password-input-hint-item ${this.active == (b + 1) ? 'active' : ''}`}>{label}</div>);
              return (<div key={b} class={['a-password-input-hint-item', (this.active == (b + 1) ? 'active' : null)]} />);
            })}
          </div>
        )}
      </div>
    );
  },
}